<template>
    <Container>
        <template v-slot:header>
            <TopBanner></TopBanner>
        </template>
        <router-view></router-view>
    </Container>
</template>
<script>
import TopBanner from "./components/TopBanner.vue";
export default {
    name: "wsj-layout",
    components: {
        TopBanner,
    },
    data() {
        return {};
    },
};
</script>
